import React from 'react'
import ClosureSurvey from 'sprockets_react/closure_survey/registry'
import ClosureSurveyData from 'sprockets_react/closure_survey/data/registry'

ClosureSurvey.HasJobBeenDoneYet = {
  onSubmit: function(onStepProgression, onRequest, onRequestCompletion) {
    this.validator.validateField('outcome')
    this.validator.isValidField('outcome') && onStepProgression()
  },

  buttonLayout: function() {
    return 'nextButton'
  },

  component: React.createClass({
    getInitialState: function() {
      const closureSurvey = ClosureSurveyData.Data;

      return {
        outcome: closureSurvey.outcome
      }
    },

    componentDidMount: function() {
      if (ClosureSurveyData.Data.outcome !== null && this.props.trigger === 'my_listings') {
        if (ClosureSurveyData.Data.outcome === 'not_going_ahead') {
          ClosureSurvey.Emitter.emit('closureSurvey:wizard:advanceToStep', ClosureSurvey.SubmitFeedback)
        }
        else {
          ClosureSurvey.Emitter.emit('closureSurvey:wizard:advanceToStep', ClosureSurvey.WhoDidTheJob)
        }
      }
      if (ClosureSurveyData.Data.outcome !== null && this.props.trigger === 'email' && (this.props.fromFastFeedback !== null && typeof this.props.fromFastFeedback !== "undefined")) {
        if (ClosureSurveyData.Data.outcome === 'job_completed') {
          ClosureSurvey.Emitter.emit('closureSurvey:wizard:advanceToStep', ClosureSurvey.RateExperience)
        }
        else if (ClosureSurveyData.Data.outcome === 'not_going_ahead') {
          ClosureSurvey.Emitter.emit('closureSurvey:wizard:advanceToStep', ClosureSurvey.SubmitFeedback)
        }
        else {
          ClosureSurvey.Emitter.emit('closureSurvey:wizard:advanceToStep', ClosureSurvey.WhoDidTheJob)
        }
      }

      $('#job-closure-modal').bootstrapValidator({ /* */ })
      ClosureSurvey.HasJobBeenDoneYet.validator = $('#job-closure-modal').data('bootstrapValidator')

      $('#outcome-radio-group').radioButtonGroup({activeRowClass: 'active'})

      this.setupValidation()
    },

    setupValidation: function() {
      ClosureSurvey.HasJobBeenDoneYet.validator.addField('outcome',
        { validators: {
            notEmpty: {
              message: 'Please select an answer'
            },
            blank: {}
          }
        }
      )
    },

    autoProgress: function(e) {
      const $selectedItem = $(e.currentTarget).find('[type="radio"]')[0]
      const providerAccountId = ClosureSurveyData.Data.providerAccountId
      ClosureSurveyData.Data.outcome = $selectedItem.value


      if (ClosureSurveyData.Data.providerAccountId !== null && (this.props.trigger === 'hire_button' || this.props.trigger === "leave_feedback_button") && $selectedItem.value === 'going_ahead') {
        ClosureSurveyData.Actions.resetData()
        ClosureSurveyData.Data.outcome = $selectedItem.value
        ClosureSurveyData.Data.providerAccountId = providerAccountId

        ClosureSurvey.Emitter.emit('closureSurvey:wizard:advanceToStep', ClosureSurvey.SubmitFeedback)
      }
      else {
        ClosureSurvey.Emitter.emit('closureSurvey:wizard:advanceToStep', ClosureSurvey.WhoDidTheJob)
      }
    },

    submitCancelledJob: function(e) {
      const $selectedItem = $(e.currentTarget).find('[type="radio"]')[0]

      ClosureSurveyData.Actions.resetData()
      ClosureSurveyData.Data.outcome = $selectedItem.value
      ClosureSurvey.Emitter.emit('closureSurvey:wizard:advanceToStep', ClosureSurvey.SubmitFeedback)
    },

    handleOutcomeRadioClick: function() {
      ClosureSurvey.Validator.$form.data('bootstrapValidator').revalidateField("outcome")
    },

    render: function() {
      return (
        <div className="form-group" onClick={this.handleOutcomeRadioClick}>
          <h3 className="mb15 mt10">Has your job been done yet?</h3>
          <div className="radio-button-box minor-bold" id="outcome-radio-group">
            <div className={"radio radius-6-top " + ((this.state.outcome === "job_completed") ? "active" : "")} onClick={this.autoProgress}>
              <div className="row">
                <div className="col-xs-10 col-sm-10 this-week">Yes</div>
                <input type="radio" defaultChecked={(this.state.outcome === "job_completed") ? 'checked' : ''} id="job_completed" name="outcome" value="job_completed" className="form-control invisible"/>
              </div>
            </div>
            <div className={"radio " + ((this.state.outcome === "going_ahead") ? "active" : "")} onClick={this.autoProgress}>
              <div className="row">
                <div className="col-xs-10 col-sm-10">Not yet!</div>
                <input type="radio"  defaultChecked={(this.state.outcome === "going_ahead") ? 'checked' : ''} id="going_ahead" name="outcome" value="going_ahead" className="form-control invisible"/>
              </div>
            </div>
            { (this.props.trigger !== "hire_button" && this.props.trigger !== "leave_feedback_button") &&
              <div className={"radio radius-6-bottom " + ((this.state.outcome === "not_going_ahead") ? "active" : "")} onClick={this.submitCancelledJob}>
                <div className="row">
                  <div className="col-xs-10 col-sm-10 asap-urgent">No, I cancelled the job</div>
                  <input type="radio" defaultChecked={(this.state.outcome === "not_going_ahead") ? 'checked' : ''} id="not_going_ahead" name="outcome" value="not_going_ahead" className="form-control invisible"/>
                </div>
              </div>
            }
          </div>
        </div>
      )
    }
  })
}
